import { Card, Col, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { formatDate, formatDateBRDDMM, formatDateInEN, formatInReal } from '../../../commons/util/HallAppUtil';

import AppLoading from '../../../commons/AppLoading';
import CashClosingFilter from '../components/CashClosingFilter';
import ConfirmModal from '../../../commons/modal/ConfirmModal';
import EmployeeAPI from '../../employee/EmployeeAPI';
import HallAppToast from '../../../commons/HallAppToast';
import ReportHeader from '../../report-full/components/ReportHeader';
import { useParams } from 'react-router-dom';

const employeeAPI = new EmployeeAPI();

const CashClosingDetails = () => {

    const [loading, setLoading] = useState(true);
    const [comissions, setCommissions] = useState([]);

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [isLoadingModal, setIsLoadingModal] = useState(false);

    const { employeeId } = useParams();

    const today = new Date();

    const firstDayOfWeek = new Date(today);
    firstDayOfWeek.setDate(today.getDate() - today.getDay());

    const lastDayOfWeek = new Date(today);
    lastDayOfWeek.setDate(today.getDate() + (6 - today.getDay()));

    const [filter, setFilter] = useState({
        startDate: formatDateInEN(firstDayOfWeek),
        endDate: formatDateInEN(lastDayOfWeek),
        employeeId: employeeId
    });

    useEffect(() => {
        findAllSummary();
    }, [filter]);

    const findAllSummary = async () => {
        try {
            setLoading(true);
            const resp = await employeeAPI.commissionDetails(filter);
            setCommissions(groupByPaymentDate(resp.data));
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setLoading(false);
        }
    };

    function groupByPaymentDate(commissions) {
        const grouped = {};

        commissions.forEach((item) => {
            const dateKey = item.paymentDate
                ? new Date(item.paymentDate).toISOString().split('T')[0]
                : 'Sem data';

            if (!grouped[dateKey]) {
                grouped[dateKey] = {
                    date: dateKey,
                    services: [],
                    totalToPay: 0,
                };
            }

            grouped[dateKey].services.push(item);
            grouped[dateKey].totalToPay += item.toPay;
        });

        return Object.values(grouped).sort((a, b) => {
            if (a.date === 'Sem data') return -1;
            if (b.date === 'Sem data') return 1;
            return new Date(b.date) - new Date(a.date);
        });
    }

    function changeDates(startDate, endDate) {
        if (endDate === null) {
            endDate = startDate;
        }

        setFilter({
            ...filter,
            startDate,
            endDate
        });
    }

    const confirmRollback = async () => {
        if (!selectedGroup) return;

        try {
            setIsLoadingModal(true);

            await employeeAPI.rollbackCommissionPayment({
                employeeId: filter.employeeId,
                paymentDate: selectedGroup.date
            });

            HallAppToast.success('Pagamento desfeito com sucesso!');

            setShowConfirmModal(false);
            setSelectedGroup(null);
            findAllSummary();

        } catch (e) {
            HallAppToast.genericError();
        } finally {
            setIsLoadingModal(false);
        }
    };

    return (
        <>
            <ReportHeader name='Detalhes Comissões' />

            <div
                style={{
                    position: 'fixed',
                    top: 60,
                    left: 0,
                    right: 0,
                    zIndex: 9999,
                    backgroundColor: 'white',
                }}
                className="filter-my-command"
            >
                <CashClosingFilter changeDates={changeDates} />
            </div>

            <div className="container" style={{ marginTop: '60px' }}>

                {loading ? <AppLoading /> : comissions.map((group, idx) => (
                    <Card
                        key={idx}
                        className={`mb-4 shadow-sm ${group.date === 'Sem data' ? 'border-warning bg-warning-subtle' : ''}`}
                    >
                        <Card.Header
                            className={`fw-bold d-flex justify-content-between align-items-center ${group.date === 'Sem data' ? 'text-warning' : 'bg-light'}`}
                        >
                            <div>
                                {group.date === 'Sem data'
                                    ? '⚠️ Sem data de pagamento'
                                    : `Pagamento em: ${formatDate(group.date)}`
                                }
                            </div>

                            {group.date !== 'Sem data' && (
                                <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => {
                                        setSelectedGroup(group);
                                        setShowConfirmModal(true);
                                    }}
                                >
                                    Desfazer pagamento
                                </button>
                            )}
                        </Card.Header>

                        <Card.Body>
                            <Row className="fw-bold border-bottom pb-2 text-muted">
                                <Col md={4}>Data / Serviço</Col>
                                <Col md={2} className="text-end">Valor do Serviço</Col>
                                <Col md={2} className="text-end">Comissão %</Col>
                                <Col md={4} className="text-end">Valor da Comissão</Col>
                            </Row>

                            {group.services.map((service, index) => (
                                <Row key={index} className="mb-2">
                                    <Col md={4}>
                                        {formatDateBRDDMM(service.serviceDate)} - {service.serviceName}
                                    </Col>
                                    <Col md={2} className="text-end">
                                        {formatInReal(service.value)}
                                    </Col>
                                    <Col md={2} className="text-end">
                                        {service.percentage}%
                                    </Col>
                                    <Col md={4} className="text-end fw-semibold">
                                        {formatInReal(service.toPay)}
                                    </Col>
                                </Row>
                            ))}

                            <hr />
                            <div className="text-end fw-bold text-success fs-6">
                                Total: {formatInReal(group.totalToPay)}
                            </div>
                        </Card.Body>
                    </Card>
                ))}

                <div style={{ height: "calc(50px + 72px)" }}></div>
            </div>

            {showConfirmModal && (
                <ConfirmModal
                    show={showConfirmModal}
                    title="Desfazer pagamento"
                    isLoading={isLoadingModal}
                    confirm={confirmRollback}
                    closeModal={() => {
                        setShowConfirmModal(false);
                        setSelectedGroup(null);
                    }}
                >
                    Deseja realmente desfazer o pagamento do dia{" "}
                    <span style={{ fontWeight: "bold" }}>
                        {selectedGroup?.date ? formatDate(selectedGroup.date) : "-"}
                    </span>?
                    <br />
                    As comissões voltarão para pendente.
                </ConfirmModal>
            )}
        </>
    );
};

export default CashClosingDetails;